module.exports = __webpack_public_path__ + "img/icon_map_51_on_010.b564f625.png";